/** Hindi: moving to a new city through Talk. */
export const moving = {
    "moving.suggest": "नए शहर जा रहे हैं?",
    "moving.no_figures": "{trade}: इस शहर के लिए अभी कमाई के आँकड़े नहीं हैं।",
    "moving.no_outlook": "उस शहर के लिए अभी कमाई के आँकड़े मेरे पास नहीं हैं।",
    "moving.listed.one": "GigSync पर {city} में {count} कामगार {trade} का काम करता है।",
    "moving.listed.other": "GigSync पर {city} में {count} कामगार {trade} का काम करते हैं।",
    "moving.listed_many": "GigSync पर {city} में {count} या उससे ज़्यादा कामगार {trade} का काम करते हैं।",
    "moving.estimates": "ये आँकड़े सार्वजनिक स्रोतों से अंदाज़ा हैं, कमाई का वादा नहीं।",
    "moving.figures": "आँकड़े",
    "moving.which_work": "आप कौन-सा काम करते हैं? फिर मैं वहाँ की आम कमाई बता सकता हूँ।",
    "moving.first": "{city} में पहले ये काम निपटाएँ:",
    "moving.no_guide": "उस शहर की गाइड अभी मेरे पास नहीं है। अभी सिर्फ़ बेंगलुरु की गाइड है।",
    "moving.general": "हर शहर में काम आने वाली बातें:",
    "moving.lines": "ये नंबर पूरे भारत में चलते हैं:",
    "moving.line.emergency": "आपातकाल: पुलिस, फ़ायर, एम्बुलेंस",
    "moving.line.women": "महिला हेल्पलाइन",
    "moving.line.eshram": "ई-श्रम हेल्पडेस्क",
    "moving.line.cyber": "साइबर अपराध और ऑनलाइन पैसों की धोखाधड़ी",
    "moving.line.legal": "मुफ़्त कानूनी मदद (NALSA)",
    "moving.stay": "कहाँ रहें",
    "moving.documents": "कागज़",
    "moving.find": "शहर जानने वाला कोई ढूँढें",
    "moving.checklist": "मेरी शिफ़्टिंग की सूची",
    "moving.places": "गाइड में रहने की जगहें ({count})",
    "moving.documents_lead": "कागज़ों के बारे में गाइड क्या कहती है। पढ़ने के लिए किसी एक पर टैप करें।",
    "moving.no_answer": "गाइड में अभी इस पर कुछ नहीं है। शहर जानने वाले किसी से पूछें, या हेल्पलाइन पर फ़ोन करें।",
    "moving.found": "{city} जानने वाले लोग, उनके अपने गिने हुए काम के साथ। किसी से पूछें, वे हाँ या ना कह सकते हैं।",
    "moving.none": "{city} जानने वाला कोई अभी मेल नहीं खाता।",
    "moving.more_ways": "किसी को ढूँढने के और तरीके",
    "moving.ask": "{name} से पूछें",
    "moving.arrive": "आप {city} कब पहुँचेंगे?",
    "moving.arrive_0": "इस हफ़्ते",
    "moving.arrive_1": "अगले हफ़्ते",
    "moving.arrive_2": "दो हफ़्ते में",
    "moving.sent": "{name} से पूछ लिया। उनका जवाब Today पर दिखेगा।",
    "moving.not_eligible": "GigSync पर {min_months} महीने और {min_jobs} पूरे काम के बाद आप नए लोगों की मदद कर सकते हैं। आपके फ़ोन में {months} महीनों में {jobs} काम गिने गए हैं।",
    "moving.list_area": "आप {city} का कौन-सा इलाक़ा सबसे अच्छे से जानते हैं?",
    "moving.list_trades": "आप नए लोगों को किस काम के बारे में बता सकते हैं? हर एक पर टैप करें, फिर हो गया।",
    "moving.list_languages": "आप कौन-सी भाषाएँ बोलते हैं? हर एक पर टैप करें, फिर हो गया।",
    "moving.list_woman": "क्या आप महिला हैं? यह सिर्फ़ इसलिए है ताकि महिला मेंटर चाहने वाली महिलाएँ आपको ढूँढ सकें।",
    "moving.list_women_only": "सिर्फ़ नई आई महिलाओं की मदद करें?",
    "moving.list_slots": "एक साथ कितने नए लोग?",
    "moving.slots": "एक साथ {n}",
    "moving.done": "हो गया",
    "moving.list_confirm": "नए लोग यह देखेंगे: {name}, {area}, {trades}, {langs} बोलते हैं, एक साथ {slots}।",
    "moving.list_yes": "मुझे दिखाएँ",
    "moving.list_no": "अभी नहीं",
    "moving.list_later": "ठीक है। जब मदद करना चाहें, फिर से कह दीजिए।",
    "moving.unlisted": "आप सूची से हट गए। नए लोग अब आपको नहीं देखते।",
    "moving.not_listed": "आप नए लोगों की मदद करने वालों की सूची में नहीं हैं।",
};
//# sourceMappingURL=moving.js.map